import { groupAccountsByOrganization } from "byzantine";

import { useCurrentUser } from "../../../../components/contexts/CurrentUserContext";
import { useUserFeatures } from "../../../../components/contexts/UserFeaturesContext";

import type Account from "byzantine/src/Account";

/**
 * Gate for Multi-Entity Aggregation UI: the institution feature is on and the
 * user's accounts actually span more than one organization. Matches the gate
 * `ComboAccountSelector` already uses for the Transfer page's org grouping,
 * including the `org_name` fallback so accounts with no `organization` (e.g.
 * personal accounts) aren't dropped from the grouped count.
 */
export const useIsMultiEntity = (accounts: Account[]): boolean => {
  const userFeatures = useUserFeatures();
  const { currentUser } = useCurrentUser();
  return (
    Boolean(userFeatures.multientity_aggregation) &&
    groupAccountsByOrganization(accounts, currentUser?.org_name).size > 1
  );
};
